module.exports = __webpack_public_path__ + "static/media/full-download.411bf530.svg";